<div class="controls-container">
    <div class="controls-header">Check box</div>

    <div class="controls-sub-header">CheckBox Default</div>
    <pm-check-box Label="CheckBox Default"></pm-check-box>

    <div class="controls-sub-header">CheckBox Disabled</div>
    <pm-check-box IsDisabled="true" IsChecked="true" Label="CheckBox Disabled"></pm-check-box>

    <div class="controls-sub-header">CheckBox Theme 1</div>
    <pm-check-box Label="CheckBox Theme 1" CheckBoxTheme="check-box-theme-1"></pm-check-box>

    <div class="controls-sub-header">CheckBox Theme 2</div>
    <pm-check-box Label="CheckBox Theme 2" CheckBoxTheme="check-box-theme-2"></pm-check-box>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/check-box/check-box.html